import EversportsLogoIcon from '@eversports/design-tokens/assets/logo/icon.svg'
import Box from '@eversports/klimt-primitives/legacy/Box'

interface Props {
  src?: string
}

const FriendUpcomingParticipationImage = ({ src }: Props) => {
  return (
    <Box
      sx={{
        borderRadius: 2,
        width: 120,
        flexShrink: 0,
        backgroundImage: `url(${src ?? EversportsLogoIcon})`,
        backgroundSize: src ? 'cover' : 'auto',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    />
  )
}

export default FriendUpcomingParticipationImage
